// extracted by mini-css-extract-plugin
export var md = "_65-4";
export var semantic = "_65-5";
export var sm = "_65-3";
export var text = "_65-6";
export var toggleInput = "_65-0";
export var toggleSwitch = "_65-1";
export var xs = "_65-2";